import React, {useEffect} from "react";
import Header from "../Components/Header";
import heroImg from '../Images/services-hero.webp'
import BreadcrumbMain from "../Components/BreadcrumbMain";
import Services from "../Components/Services";
import StatsBox from "../Components/StatsBox";
import ProcessSection from "../Components/Process";
import AwardsSection from "../Components/AwardsSection";
import Cta from "../Components/Cta";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from '../Schemas/breadcrumbSchema'

const ServicesPg=()=>{
    useEffect(() => {
            document.title =
              "Property Settlement Services Perth | LDL Settlement Services";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Explore professional residential, commercial, strata, subdivision, and property transfer settlement services across Perth and Western Australia."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://ldlsettlementservices.com.au/services");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Property Settlement Services Perth | LDL Settlement Services"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Explore professional residential, commercial, strata, subdivision, and property transfer settlement services across Perth and Western Australia."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/services");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/service-img.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Property Settlement Services Perth | LDL Settlement Services"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Explore professional residential, commercial, strata, subdivision, and property transfer settlement services across Perth and Western Australia."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/service-img.webp"
            );
          }
          }, []);

  const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
 {
    name: "Services"
  }
]);
    return(
        <>

<SchemaMarkup schema={breadcrumbs} />

         <Header
        showBreadcrumb={true}
        pageName="Services"
      />

      <BreadcrumbMain
      subTitle="OUR SERVICES"
      title="Property Settlement Services in Perth & Western Australia"
      description="At LDL Settlement Services, we provide a comprehensive range of settlement solutions tailored to your needs."
      image={heroImg}
      showIcons={false}
      extraText="Our experienced team ensures every transaction is handled with accuracy, care and efficiency."
    />

     {/**SERVICES GRID */}
    <Services
        isSlider={false}
    />

    {/**STATS SECTION */}
    <StatsBox />

     {/**HOW WE MAKE IT EASY FOR YOU SECTION */}
    <ProcessSection />

      {/**AWARDS SECTION */}
   <AwardsSection />

   {/**CTA SECTION */}
    <Cta />

        </>
    )
}
export default ServicesPg;